// @ts-strict-ignore
import { useCart } from '@/entities/cart'

import { Button } from '@/shared/ui'

import styles from './basket-clear-modal.module.scss'

/**
 * Content for clear basket modal
 * @param onOk -
 */
export const BasketClearModal = ({ onOk }) => {
	const { clearCart } = useCart()

	const onClick = () => {
		clearCart()
		onOk()
	}

	return (
		<div className={styles.modal}>
			<h2 className={styles.title}>Удаление товаров</h2>
			<p className={styles.description}>
				Вы точно хотите удалить выбранные товары?
				<br /> Отменить действие будет невозможно.
			</p>
			<Button className={styles.button} onClick={onClick} theme="primary">
				Удалить
			</Button>
		</div>
	)
}
